'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _fluxActions = require('flux-actions');

var _Event = require('MeetingsLib/models/Event');

var _Event2 = _interopRequireDefault(_Event);

var _BookingLifecycle = require('MeetingsLib/models/BookingLifecycle');

var _BookingLifecycle2 = _interopRequireDefault(_BookingLifecycle);

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var eventInitialState = (0, _Event2.default)();

var event = (0, _fluxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.SET_EVENT_DATE, function (state, action) {
  return state.set('dateString', action.date).set('dateTime', null);
}), _defineProperty(_handleActions, _ActionTypes2.default.SET_EVENT_DATE_TIME, function (state, action) {
  return state.set('dateTime', action.dateTime);
}), _defineProperty(_handleActions, _ActionTypes2.default.BOOKING_TIME_CONFLICT, function (state) {
  return state.set('dateTime', null);
}), _defineProperty(_handleActions, _ActionTypes2.default.SET_EVENT_DURATION, function (state, action) {
  return state.set('duration', action.duration).set('dateTime', null);
}), _defineProperty(_handleActions, _ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var durations = action.payload.bookInfo.customParams.durations;
  var stateWithDuration = state.set('duration', durations.first());
  var formFields = action.payload.bookInfo.customParams.formFields;
  return stateWithDuration.set('formFields', formFields);
}), _handleActions), eventInitialState);

var postResponseInitialState = null;

var postResponse = (0, _fluxActions.handleActions)(_defineProperty({}, _ActionTypes2.default.MEETING_CREATE_SUCCEEDED, function (state, action) {
  return action.payload;
}), postResponseInitialState);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _BookingLifecycle2.default();
  var action = arguments[1];

  return state.set('event', event(state.event, action)).set('postResponse', postResponse(state.postResponse, action));
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/bookingLifecycle.js
// module id = 521
// module chunks = 0